import Next from '../../Stores/Next';
import Product from '../../Stores/Product';
import {get} from 'svelte/store';

export default class Base {
	store(item) {
		return get(item);
	}

	product() {
		if (!this.$product)
			this.$product = this.store(Product);

		return this.$product;
	}

	update(wait) {
		Product.set(this.product());
		Next.setNext(wait);
	}

	validImage(uri) {
		return uri ? uri.replace(/^\//, '') : '';
	}
}